import ApiService from './ApiService'

import HARDCODE from '../business-const/HardCode/HardCode'

import AuthService from './AuthService'

import {
    usuarioInfo,
} from './UsuarioService'



class ApoliceService extends ApiService {

    constructor() {
        super(HARDCODE.apiApolice)
    }

    async atualizarApoliceAgenteList(variaveisGlobais, idUsuario, idArquivo, jsonApoliceAgenteList) {

        const apoliceListDTO = {
            idUsuarioLogado: AuthService.obterUsuarioLogado(variaveisGlobais),
            idUsuario: idUsuario,
            idArquivo: idArquivo,
	        jsonApoliceAgenteList: jsonApoliceAgenteList,
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.post(variaveisGlobais, HARDCODE.apiApoliceAtualizarApoliceAgenteList,
            apoliceListDTO, false)
    }
}

export default ApoliceService